<template>
  <my-dialog title="门店加工订单详情" dialogType="form" :visible.sync="showDialog" :close-on-click-modal="false"
    @close="closeDialog" width="80%">
    <detail ref="detail"></detail>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">关闭</el-button>
      <el-button v-if="this.$checkBtnPermission('/order/index', 'cancelOrder') && orderType === 1 && state != 6  && state != 10" size="small" type="danger"
        @click="handleCancelOrder">取消订单</el-button>
      <el-button v-if="this.$checkBtnPermission('/order/index', 'submit') &&  orderType === 1 && state === 2" size="small" type="danger"
        @click="handleSubmitOrder">提交订单</el-button>
      <el-button v-if="this.$checkBtnPermission('/order/index', 'submit') && orderType === 1 && state === 6 && (linkOrderKeyId === '' || linkOrderKeyId === null)" size="small" type="danger"
        @click="handleShowInnerDialog">订单售后</el-button>
    </div>
    
    <el-dialog width="45%" title="订单售后" :visible.sync="innerVisible" append-to-body :close-on-click-modal="false">
      售后原因:
         <el-input v-model="afterSaleReason" placeholder="请输入售后原因" size="small" type="text" maxlength="50" minlength="1" clearable show-word-limit></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="innerVisible = false">关闭</el-button>
        <el-button size="small" type="primary" @click="handleAfterSaleOrder">确认</el-button>
      </div>
    </el-dialog>
  </my-dialog>
</template>
<script>
import { CancelStoreOrder, SubmitStoreOrder,CreateAfterSaleOrder } from "@/api/storeOrderApi.js";
import detail from "./detail.vue";
export default {
  props: [],
  data() {
    return {
      showDialog: false,
      keyId: "",
      state: 0,
      linkOrderKeyId: '',
      orderType: 1,
      innerVisible: false,
      afterSaleReason: '',
    };
  },
  computed: {},
  watch: {},
  components: {
    detail,
  },
  created() { },
  methods: {
    // 显示
    showSeeDetailDialog(row,type = 1) {
      this.showDialog = true;
      this.state = row.state;
      this.linkOrderKeyId = row.linkOrderKeyId;
      this.orderType = type;
      this.afterSaleReason = '';
      // 使用$nextTick确保DOM更新完成后再调用子组件方法
      this.$nextTick(() => {
        if (this.$refs.detail) {
          this.$refs.detail.getDetailDialog(row,false,type);
        } else {
          this.$message({ type: "error", message: "无法访问详情组件" });
        }
      });
      this.keyId = row.keyId;
    },
    // 关闭
    closeDialog() {
      this.showDialog = false;
    },
    // 取消订单
    handleCancelOrder() {
      this.$confirm("确定取消订单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 调用取消订单接口
          CancelStoreOrder({
            keyId: this.keyId,
          })
            .then((res) => {
              if (res.code == 1) {
                this.$message({
                  type: "success",
                  message: "取消订单成功",
                });
                this.closeDialog();
                this.$parent.getListData();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消取消订单",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消取消订单",
          });
        });
    },
    // 提交订单
    handleSubmitOrder() {
      this.$confirm("确定提交订单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 调用提交订单接口
          SubmitStoreOrder({
            keyId: this.keyId,
          })
            .then((res) => {
              if (res.code == 1) {
                this.$message({
                  type: "success",
                  message: "提交订单成功",
                });
                this.closeDialog();
                this.$parent.getListData();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消提交订单",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消提交订单",
          });
        });
    },
    // 创建售后订单
    handleAfterSaleOrder(){
      if (!this.afterSaleReason) {
        this.$message({
          type: "error",
          message: "请输入售后原因",
        });
        return;
      }
      this.$confirm("确定创建售后订单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 调用订单售后接口
          CreateAfterSaleOrder({
            keyId: this.keyId,
            afterSaleReason: this.afterSaleReason,
          })
            .then((res) => {
              if (res.code == 1) {
                this.$message({
                  type: "success",
                  message: "创建售后订单成功，售后订单号：" + res.data,
                });
                this.afterSaleReason = '';
                this.innerVisible = false;
                this.closeDialog();
                this.$parent.getListData();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消订单售后",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消订单售后",
          });
        });
    },
    // 显示售后订单弹窗
    handleShowInnerDialog(){
      this.innerVisible = true;
      this.afterSaleReason = '';
    },
  },
};
</script>
<style scoped lang="scss"></style>